/** The type of content that you want to retrieve. */
export enum ContentType {
  /** A normal page that holds content associated with it. */
  Page = 'page',
  /** A type of content that could be shared across pages. */
  Fragment = 'fragment',
  /** A tile content that can be used to display content in a grid. */
  Tile = 'tile',
  /** Represents a generic model that can hold any type of content. */
  Model = 'model',
  /** A category content page that can be used to display content in a category. */
  Category = 'category',
  /** A product content page that can be used to display content on a product. */
  Product = 'product',
  /** A promotion message content type for promotional messaging. */
  PromotionMessage = 'promotion-message'
}
